var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloudFormationLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_705_7827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0614 31.9266L10.3334 32.2347L24.0727 36.1216L24.135 33.7123L14.5125 31.3023L14.0416 31.1328L10.0614 31.9266Z",
    fill: "#B7CA9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9381 31.9266L23.9063 36.6011L23.8645 33.7123L33.4869 31.3024L33.9063 30.8313L37.9381 31.9266Z",
    fill: "#B7CA9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8645 15.4137L33.4869 17.6518L37.7188 17.4515L37.9381 17.0282L24.5313 12.2119L23.8645 15.4137Z",
    fill: "#3C4929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5125 31.3023L10.0614 31.9265L9.9375 31.4653V17.514L10.0614 17.0283L14.0834 17.3269L14.5125 17.6525V31.3023Z",
    fill: "#759C3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.135 15.4137L14.5125 17.6519L10.0614 17.0283L10.2291 16.7654L24.0727 12.8333L24.135 15.4137Z",
    fill: "#3C4929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9808 5.03882L8 13.0892L8.00763 35.8704L23.9808 43.9165L24.2188 43.5559V5.50664L23.9808 5.03882ZM19.3077 34.696L10.0614 31.9265V17.0283L19.3077 14.2598V34.696ZM33.4869 31.3023L37.9381 31.9265L38.1875 31.4861V17.4516L37.9381 17.0283L33.4869 17.6524V31.3023Z",
    fill: "#4B612C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9807 43.9165L39.9924 35.8709L40 13.0898L23.9807 5.03882V43.9165ZM28.6916 14.2598L37.9381 17.0283V31.9265L28.6916 34.696V14.2598Z",
    fill: "#759C3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_705_7827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 38.9278,
    fill: "white",
    transform: "translate(8 5.03613)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloudFormationLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cloud-formation-logo.f8ffdfeae0581af6a072f2eae2b2241e.svg";